import React from 'react'
import { Button } from '@faststore/ui'
import { useUI } from 'src/sdk/ui/Provider'
import { useSession } from 'src/sdk/session'
import type { CartItem } from 'src/sdk/cart'
import {
  createCartItem,
  handleAddToCart,
} from 'src/components/AssembleYourBracelet/AssembleResume/HandleMinicart'
import type { Buyable } from 'src/contexts/InsiderBuyTogetherContext/InsiderBuyTogetherContext'

interface Props {
  itemsCart: CartItem[]
  cartId: string
  selectedItems: Buyable[]
}

export default function InsiderBuyTogetherBuyButton({
  itemsCart,
  cartId,
  selectedItems,
}: Props) {
  const { openCart } = useUI()
  const {
    currency: { code },
  } = useSession()

  const productsToAdd: CartItem[] = selectedItems.map((item) =>
    createCartItem({ ...item.raw, quantity: item.raw.quantity ?? 1 })
  )

  const totalPrice = selectedItems.reduce(
    (sum, item) => sum + item.price * (item.raw.quantity ?? 1),
    0
  )

  const formattedTotal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(totalPrice)

  const count = selectedItems.length

  let summaryText: string | null = null
  if (count === 1) {
    summaryText = `Compre 1 item por`
  } else if (count === 2) {
    summaryText = `Compre 2 itens por`
  } else if (count >= 3) {
    summaryText = `Compre o look por`
  }

  const disabled = count === 0

  const handleClick = () => {
    handleAddToCart({
      products: productsToAdd,
      code,
      totalPrice,
      cartId,
      itemsCart,
    }).then(() => openCart())
  }

  return (
    <div className="AddToCart">
      {!disabled && summaryText && (
        <div className="buy-complete-summary">
          <span>{summaryText}</span>
          <strong>{formattedTotal}</strong>
        </div>
      )}
      <Button
        onClick={disabled ? undefined : handleClick}
        id={disabled ? 'btn-add-to-cart-disabled' : 'btn-add-to-cart'}
      >
        {disabled ? 'Selecione um item' : `Comprar look`}
      </Button>
    </div>
  )
}
